import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  GqlVideoFragment,
  GqlVideoTrailerType,
} from '../apollo/generated/graphql';
import { usePlayback } from './usePlayback';
import { isChannelViewVar } from './useOverlayProps';
import { useSelectedVideo } from './useSelectedVideo';
import { useCallback } from 'react';
import { useVideoAccessAction } from './useVideoAccessAction';
import { AccessAction } from '../types/enums';

type UseVideoPlayback =
  | {
      playVideoText: string;
      playVideo(): void;
      pauseVideo(): void;
    }
  | undefined;

export function useVideoPlayback(video: GqlVideoFragment): UseVideoPlayback {
  const { t } = useTranslation();
  const { play, pause } = usePlayback();
  const videoAccessAction = useVideoAccessAction(video);
  const { selectVideo } = useSelectedVideo();

  const playVideo = useCallback(() => {
    isChannelViewVar(false);
    selectVideo(video);
    play();
  }, [play, selectVideo, video]);

  if (video) {
    const { trailerEnabled, trailerType } = video.viewerOptions;

    if (videoAccessAction === AccessAction.None) {
      return {
        playVideoText: t('widget.overlay-buttons.play-video'),
        playVideo,
        pauseVideo: pause,
      };
    }

    if (trailerEnabled) {
      return {
        playVideoText:
          trailerType === GqlVideoTrailerType.Default
            ? t('widget.overlay-buttons.watch-preview')
            : t('widget.overlay-buttons.watch-trailer'),
        playVideo,
        pauseVideo: pause,
      };
    }
  }
}
